"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleColumnType = exports.isBoolean = exports.isDatetime = exports.isText = exports.isNumber = exports.isDecimal = exports.isInteger = void 0;
/**
 * @param type
 * @internal
 */
const isInteger = (type) => {
    return [
        '__int4',
        '__int8',
        'int',
        'tinyint',
        'bigint',
        'int2',
        'int4',
        'int8',
        'smallint',
        'mediumint',
        'serial',
        'integer',
        'byteint',
        'int64',
    ].includes(type.toLowerCase());
};
exports.isInteger = isInteger;
/**
 * @param type
 * @internal
 */
const isDecimal = (type) => {
    return [
        'basemeasure',
        'calculatedmeasure',
        'float',
        'float4',
        'float8',
        'double precision',
        'double',
        'numeric',
        'decimal',
        'real',
        'number',
        'float64',
    ].includes(type.toLowerCase());
};
exports.isDecimal = isDecimal;
/**
 * @param type
 * @internal
 */
const isNumber = (type) => {
    return (0, exports.isInteger)(type) || (0, exports.isDecimal)(type) || type === 'numeric-attribute';
};
exports.isNumber = isNumber;
/**
 * @param type
 * @internal
 */
const isText = (type) => {
    return [
        'textdimension',
        'string',
        'varchar',
        'text',
        'ntext',
        'char',
        'character',
        'character varying',
        'smalltext',
        'nchar',
        'nvarchar',
        'json',
        'jsonb',
        'object',
        'text-attribute',
    ].includes(type.toLowerCase());
};
exports.isText = isText;
/**
 * @param type
 * @internal
 */
const isDatetime = (type) => {
    return [
        'datelevel',
        'date',
        'time',
        'datetime',
        'timestamp without time zone',
        'timestamp',
        'timestamp with time zone',
        'timestamp(6)',
        'timestamp_tz',
        'timestamp_ntz',
        'timestamp_ltz',
        'timestampltz',
        'timestampntz',
        'timestamptz',
        'datetime64[ns]',
        'timewithtimezone',
        'timestampwithtimezone',
        'timestamp_with_timezone',
    ].includes(type.toLowerCase());
};
exports.isDatetime = isDatetime;
/**
 * @param type
 * @internal
 */
const isBoolean = (type) => {
    return ['bool', 'boolean', 'bit', 'logical'].includes(type.toLowerCase());
};
exports.isBoolean = isBoolean;
/**
 * @param type
 * @internal
 */
const simpleColumnType = (type) => {
    if ((0, exports.isNumber)(type)) {
        return 'number';
    }
    if ((0, exports.isDatetime)(type)) {
        return 'datetime';
    }
    if ((0, exports.isText)(type)) {
        return 'text';
    }
    if ((0, exports.isBoolean)(type)) {
        return 'boolean';
    }
    return 'text';
};
exports.simpleColumnType = simpleColumnType;
